import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputBase,
  TableCell,
  TableRow,
} from "@mui/material";
import { callAPI } from "../../../App/Helpers/callApi";
import LoadingBar from "../../../App/Components/LoadingBar/LoadingBar";
import {
  addFeaturedEvents,
  getEventsNotFeatured,
  getFeaturedEvents,
} from "../FeaturedEventsService";
import { basicConvertDate } from "../../../App/Helpers/DateConverters";
import { basicSort } from "../../../App/Helpers/BasicSort";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    minWidth: "400px",
    display: "flex",
    flexDirection: "column",
  },
  error: {
    color: theme.palette.error.main,
  },
  search: {
    position: "relative",
    paddingLeft: "5px",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "rgba(0,0,0,.1)",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,.2)",
    },
    marginTop: "10px",
    width: "50%",
    "&.Mui-focused": {
      width: "90%",
      transition: "width 0.3s",
    },
    transition: "width 0.3s",
    [theme.breakpoints.down("md")]: {
      width: "50%",
      "&.Mui-focused": {
        width: "100%",
        transition: "width 0.3s",
      },
    },
  },
}));
export default function AddFeaturedEventModal({
  openModal,
  client,
  setShowSignifier,
  setResponseMessage,
  setShowError,
  setTableData,
}) {
  const classes = useStyles();
  const [processing, setProcessing] = useState(false);
  const [events, setEvents] = useState([]);
  const [showInputError, setShowInputError] = useState(false);
  const [searchVal, setSearchVal] = useState("");

  const checkInput = () => {
    for (var i in events) {
      if (events[i].add) {
        return true;
      }
    }
    return false;
  };

  function addEvents() {
    if (!checkInput()) {
      setShowInputError(true);
      return;
    }
    var addEventsList = [];
    for (var i in events) {
      if (events[i].add) {
        addEventsList.push(events[i]);
      }
    }

    callAPI(
      addFeaturedEvents(client.id, addEventsList),
      "Events Added",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getFeaturedEvents(client.id).then((response) => {
        response.sort((a, b) => {
          const order = basicSort(a.order, b.order);
          if (order !== 0) return order;
          return a[1] - b[1];
        });
        response.forEach(
          (row) => (row.event.startDate = basicConvertDate(row.event.startDate))
        );
        response.forEach(
          (row) => (row.event.endDate = basicConvertDate(row.event.endDate))
        );
        setTableData(response);
        openModal(false);
      });
    });
  }

  const updateAdded = (id) => {
    var copy = [...events];
    for (var i in copy) {
      if (copy[i].id === id) {
        copy[i].add = !copy[i].add;
      }
    }

    setEvents(copy);
  };

  useEffect(() => {
    if (client !== null) {
      getEventsNotFeatured(client.id).then((response) => {
        let activeEventsNotFeatured = response.filter(
          (event) => event.isActive
        );
        activeEventsNotFeatured.forEach((row) => (row.add = false));
        activeEventsNotFeatured.forEach(
          (row) => (row.startDate = basicConvertDate(row.startDate))
        );
        activeEventsNotFeatured.forEach(
          (row) => (row.endDate = basicConvertDate(row.endDate))
        );

        setEvents(activeEventsNotFeatured);
      });
    }
  }, []);

  return (
    <div className={classes.root}>
      <LoadingBar loading={processing} />
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Add Featured Events
            </FormHelperText>
            <InputBase
              className={classes.search}
              placeholder="Search..."
              onChange={(e) => setSearchVal(e.target.value)}
            />
            <Grid container spacing={1}>
              {showInputError && (
                <FormHelperText className={classes.error}>
                  At least one event required
                </FormHelperText>
              )}
              {events
                .filter((event) =>
                  event.title.toLowerCase().includes(searchVal.toLowerCase())
                )
                .map((event, index) => (
                  <TableRow key={index} style={{ width: "100%" }}>
                    <TableCell align="left" style={{ width: "70%" }}>
                      {event.title}
                    </TableCell>
                    <TableCell align="middle" style={{ width: "50%" }}>
                      {event.startDate}
                    </TableCell>
                    <TableCell align="middle" style={{ width: "50%" }}>
                      {event.endDate}
                    </TableCell>
                    <TableCell align="right" style={{ width: "50%" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            checked={event.add}
                            onChange={() => updateAdded(event.id)}
                          />
                        }
                        label=""
                      />
                    </TableCell>
                  </TableRow>
                ))}
              <Grid
                container
                justifyContent="flex-end"
                direction="row"
                style={{ marginRight: "10px" }}
              >
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ color: "#82B288", marginTop: "20px" }}
                    type="submit"
                    variant="outlined"
                    fullWidth
                    onClick={() => openModal(false)}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ marginTop: "20px", marginLeft: "10px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => addEvents()}
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
